import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "@reduxjs/toolkit";
// enums
import { EView } from "cms/enums/EView";
import { EViewType } from "cms/enums/EViewType";
import { EContentType } from "cms/enums/EContentType";
// actions
import { TMainPageLayout } from "../type";
// interfaces
import IClientLanguage from "core/interfaces/IClientLanguage";
import IClientSiteSettingDetail from "cms/interfaces/IClientSiteSettingDetail";
import LanguageVersionSelector from "cms/utilities/LanguageVersionSelector";
import ILanguageVersionList from "cms/interfaces/ILanguageVersionList";
import { Link } from "react-router-dom";
import ContactForm from "components/ContactForm";
import ContactInfoBlock from "components/ContactInfoBlock";


function mapStateToProps ( state: any ) {
    console.log("MNPG006.mapStateToProps: ", state);

    const webApplicationLanguage:IClientLanguage   = state.CoreStore.language?.payload;
    const webApplicationLanguageCode:string        = webApplicationLanguage.code;
    const webApplicationLanguageISOCode:string     = state.CoreStore.languageCode?.payload;

    const siteSettingDetailPayload:IClientSiteSettingDetail    = state.SiteSettingStore.details?.payload;

    return {

        webApplicationLanguage,
        webApplicationLanguageCode,
        webApplicationLanguageISOCode,

        siteSettingDetailPayload
    
    }
}

function mapDispatchToProps ( dispatch: Dispatch ) {
    console.log("MNPG006.mapDispatchToProps");

    return {

    }
}

const connector = connect(mapStateToProps, mapDispatchToProps);


/* types */
type PropsFromRedux = ConnectedProps<typeof connector>


/* component */
function MMNPG006Loader () {

    return (
        <></>
    )

}

function MNPG006 ( props:TMainPageLayout<PropsFromRedux> ) {
    console.log("MNPG006.rendered", props)

    const parentLanguageVersion = LanguageVersionSelector<ILanguageVersionList|null>({
        languageVersions: props.parentPayload?.languageVersions,
        filters: [
            { view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.MAIN_PAGE_ITEM },
            { view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.DEFAULT }
        ],
        type: "find"
    });

    const weAreHereToHelp = LanguageVersionSelector<ILanguageVersionList|null>({
        languageVersions: props.parentPayload?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, name: "weAreHereToHelp" }
        ],
        type: "find"
    });
    const contactOurTeam = LanguageVersionSelector<ILanguageVersionList|null>({
        languageVersions: props.parentPayload?.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, name: "contactOurTeam" }
        ],
        type: "find"
    });
    
    return (
        <section className="contact-two">
            <div className="container">
                <div className="row">
                    <div className="col-xl-5 col-lg-5">
                        <div className="contact-two__left">

                            <div className="section-title text-left">
                                <div className="section-title__tagline-box">
                                    <span className="section-title__tagline">{weAreHereToHelp?.value}</span>
                                </div>
                                <h2 className="section-title__title">{contactOurTeam?.value}</h2>
                            </div>
                            
                            <div className={`tw-border-t tw-border-gray-300 tw-mb-0`} />

                            <ContactInfoBlock 
                                languageVersions={props.parentPayload?.languageVersions} 
                                className="tw-mt-10" 
                            />

                        </div>
                    </div>
                    <div className="col-xl-7 col-lg-7">
                        <div className="contact-two__right">
                            <ContactForm 
                                languageVersions={props.parentPayload.languageVersions}
                                className="contact-two__form" 
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )

}

const Component = React.memo(MNPG006, ( prevProps: TMainPageLayout<PropsFromRedux>, nextProps: TMainPageLayout<PropsFromRedux> ) => {
    return true;
});

export default connector(Component);
